import { REQUEST_URLS, fetcher } from '@/endpoints/fionaMainApi';
import useSWRImmutable from 'swr/immutable';

export const useGetUserPropertiesAssignedAgents = () => {
  const { data, error, isLoading, mutate } = useSWRImmutable<{ assignedTo: string[] }, Error>(
    REQUEST_URLS.FETCH_ACCOUNT_PROPERTY_ASSIGNED_TO(),
    fetcher,
  );
  return {
    data,
    isLoading,
    isError: error,
    mutate,
  };
};
